import service from '@/commons/config/service.config'
import BaseService from './BaseService'
import ErrorService from './ErrorService'
import { Deserialize, Serialize } from 'cerialize'
import { StorageService } from '@/services/storage.service'

import { stringify } from 'qs'
import store from '../../store/index'
/**
 * @typedef {Http}
 */
export default class HttpService extends BaseService {
  // static api = ''
  // static entity = ''
  /**
   * @param {String} api
   * @param {String} entity
   * @param {String} resource
   * @param {Object} options
   * @param {Object} http
   */
  constructor (api, entity, options = {}, http = null) {
    super(options)
    this.api = api
    this.entity = entity
    this.http = http || service
  }

  /**
   * @param {String} path
   * @param {Object} options
   */
  static build (options) {
    return new this(this.api, this.entity, options)
  }

  static setHeader () {
    const data = StorageService.getAuthdata()
    service.defaults.headers.common.Authorization = `Bearer ${data.token}`
    service.defaults.headers.common['Content-Type'] = 'application/json'
    service.defaults.headers.common.Accept = 'application/json'
  }

  static removeHeader () {
    service.defaults.headers.common = {}
  }

  /**
   * @param {String} url
   * @returns {*|Promise<any>}
   */
  get (param = {}, url = '') {
    const api = url === '' ? this.api : url
    return this.http
      .get(api, {
        params: param,
        paramsSerializer: params => {
          return stringify(params, { arrayFormat: 'repeat' })
        }
      })
      .then(this.constructor.then)
      .catch((e) => {
        if (e instanceof ErrorService) {
          e.showError()
        } else {
          const alert = new ErrorService(e)
          alert.showError()
        }
      })
  }

  getRaw (param = {}, url = '') {
    const api = url === '' ? this.api : url
    return this.http
      .get(api + param)
      .then(this.constructor.then)
      .catch((e) => {
        if (e instanceof ErrorService) {
          e.showError()
        } else {
          const alert = new ErrorService(e)
          alert.showError()
        }
      })
  }

  /**
   * @param {String} url
   * @param {Object} data
   * @returns {*|Promise<any>}
   */
  post (data, url = '', params = {}) {
    const api = url === '' ? this.api : url
    const deserializeData = Deserialize(data, this.entity)
    return this.http
      .post(api, Serialize(deserializeData), params)
      .then(this.constructor.then)
      .catch((e) => {
        if (e instanceof ErrorService) {
          e.showError()
        } else {
          const alert = new ErrorService(e)
          alert.showError()
        }
      })
  }

  postFilter (data, url = '', param = {}) {
    const api = url === '' ? this.api : url
    return this.http
      .post(api, data, { params: param })
      .then(this.constructor.then)
      .catch((e) => {
        if (e instanceof ErrorService) {
          e.showError()
        } else {
          const alert = new ErrorService(e)
          alert.showError()
        }
      })
  }

  /**
   * @param {String} url
   * @param {Object} data
   * @returns {*|Promise<any>}
   */
  put (data, url = '', params = {}) {
    const api = url === '' ? this.api : url
    // const deserializeData = Deserialize(data, this.entity)
    return this.http
      .put(api, data, params)
      .then(this.constructor.then)
      .catch((e) => {
        if (e instanceof ErrorService) {
          e.showError()
        } else {
          const alert = new ErrorService(e)
          alert.showError()
        }
      })
  }

  /**
   * @param {String} url
   * @param {Object} data
   * @returns {*|Promise<any>}
   */
  putVer2 (data, url = '', param = {}) {
    const api = url === '' ? this.api : url
    const deserializeData = Deserialize(data, this.entity)
    return this.http
      .put(api, Serialize(deserializeData), { params: param })
      .then(this.constructor.then)
      .catch((e) => {
        if (e instanceof ErrorService) {
          e.showError()
        } else {
          const alert = new ErrorService(e)
          alert.showError()
        }
      })
  }

  /**
   * @param {String} url
   * @param {Object} data
   * @returns {*|Promise<any>}
   */
  patch (data, url = '') {
    const api = url === '' ? this.api : url
    // const deserializeData = Deserialize(data, this.entity)
    return this.http
      .patch(api)
      .then(this.constructor.then)
      .catch((e) => {
        if (e instanceof ErrorService) {
          e.showError()
        } else {
          const alert = new ErrorService(e)
          alert.showError()
        }
      })
  }

  /**
   * @param {String} url
   * @returns {*|Promise<any>}
   */
  delete (id, isPath = true) {
    return this.http
      .delete(isPath ? this.api + `/${id}` : this.api, { params: (isPath ? {} : { id: id }) })
      .then(this.constructor.then)
      .catch((e) => {
        if (e instanceof ErrorService) {
          e.showError()
        } else {
          const alert = new ErrorService(e)
          alert.showError()
        }
      })
  }

  deleteNew (id, url = '', isPath = true) {
    const api = url === '' ? this.api : url
    return this.http
      .delete(isPath ? api + `/${id}` : api, { params: (isPath ? {} : { id: id }) })
      .then(this.constructor.then)
      .catch((e) => {
        if (e instanceof ErrorService) {
          e.showError()
        } else {
          const alert = new ErrorService(e)
          alert.showError()
        }
      })
  }

  /**
   * @param {String} url
   * @returns {*|Promise<any>}
   */
  deleteWithParam (data, url = '', param = {}) {
    const api = url === '' ? this.api : url
    const deserializeData = Deserialize(data, this.entity)
    return this.http
      .delete(api, { data: Serialize(deserializeData), params: param })
      .then(this.constructor.then)
      .catch((e) => {
        if (e instanceof ErrorService) {
          e.showError()
        } else {
          const alert = new ErrorService(e)
          alert.showError()
        }
      })
  }

  /**
   * @param {Object} response
   * @returns {Object}
   */
  generateTable (param = {}, path = '') {
    const api = (path === '') ? this.api : this.api + path
    return this.http
      .get(api, {
        params: param,
        transformResponse: [
          (data) => {
            if (data === 'Invalid token') {
              return data
            } else {
              const res = JSON.parse(data)
              if (res.data) {
                return {
                  data: {
                    data: Deserialize(res.data.contents, this.entity),
                    total: res.data.pages.totalElements,
                    size: res.data.pages.size,
                    page: res.data.pages.number
                  },
                  status: res.status,
                  message: res.message,
                  success: res.success
                }
              } else {
                return res
              }
            }
          }
        ]
      })
      .then(this.constructor.then)
      .catch((e) => {
        if (e instanceof ErrorService) {
          e.showError()
        } else {
          const error = new ErrorService(e)
          error.showError()
        }
      })
  }

  upload (data, url = '') {
    const api = url === '' ? this.api + '/upload' : url
    const loader = store.getters['loader/showLoader']
    const config = {
      onUploadProgress: progressEvent => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        if (percentCompleted <= 99) {
          store.commit('loader/startPercentage', { percentage: percentCompleted })
        }
      },
      showLoader: loader
    }
    return this.http
      .post(api, data, config)
      .then(this.constructor.then,
        store.commit('loader/startPercentage', { percentage: 100 }))
      .catch((e) => {
        if (e instanceof ErrorService) {
          e.showErrorUpload()
        } else {
          const alert = new ErrorService(e)
          alert.showError()
        }
      })
  }

  getFile (param = {}, url = '', filename) {
    const api = url === '' ? this.api : url
    return this.http
      .get(api, { params: param, responseType: 'blob' })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
      })
      .catch((e) => {
        if (e instanceof ErrorService) {
          e.showError()
        } else {
          const alert = new ErrorService(e)
          alert.showError()
        }
      })
  }

  previewFile (param = {}, url = '', filename) {
    const api = url === '' ? this.api : url
    return this.http
      .get(api, { params: param, responseType: 'arraybuffer' })
      .then((response) => {
        const file = new Blob([response.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(file)
        // const link = document.createElement('a')
        // link.href = url
        // link.setAttribute('download', filename)
        // document.body.appendChild(link)
        // link.click()
        return url
      })
      .catch((e) => {
        if (e instanceof ErrorService) {
          e.showError()
        } else {
          const alert = new ErrorService(e)
          alert.showError()
        }
      })
  }

  previewFileTab (param = {}, url = '', filename) {
    const api = url === '' ? this.api : url
    return this.http
      .get(api, { params: param, responseType: 'blob' })
      .then((response) => {
        const file = new Blob([response.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(file, { oneTimeOnly: true })
        // const link = document.createElement('a')
        // link.href = url
        // link.setAttribute('download', filename)
        // document.body.appendChild(link)
        // link.click()
        return url
      })
      .catch((e) => {
        if (e instanceof ErrorService) {
          e.showError()
        } else {
          const alert = new ErrorService(e)
          alert.showError()
        }
      })
  }

  addWatermark (param = {}, url) {
    const api = url === '' ? this.api : url
    return this.http
      .get(api, { params: param })
      .then((response) => {
        return response
      })
      .catch((e) => {
        if (e instanceof ErrorService) {
          e.showError()
        } else {
          const alert = new ErrorService(e)
          alert.showError()
        }
      })
  }
}
